// extracted by mini-css-extract-plugin
export var logo = "_hw-2";
export var logoWrapper = "_hw-1";
export var strip = "_hw-0";